import * as React from 'react';
import styled from 'styled-components';
import { AcceptButton } from './acceptButtonComponent';
import { SkipButton } from './skipButtonComponent';

type Props = {
    // buttonText: string,
}
export const PresentCard: React.FC<Props> = (props) => {
  const PresentCardDiv = styled.div`
    border: solid;
    margin-top: 50px;
    border-width: 3px;
    color: #1F1F1F;
    border-style: none;
    background: linear-gradient(339.68deg, rgba(239, 239, 239, 0.6) 4.62%, rgba(255, 255, 255, 0.45) 93.97%);
    box-shadow: inset 0px 1px 0px rgba(255, 255, 255, 0.25);
    border-radius: 10px;
    width: 320px;
    height: 534.44px;
    backdrop-filter: blur(10px);

    display: inline-block;
    justify-content: center;
    text-align: center;
  `;
  const PresentImage = styled.img`
    height: 200px;
    margin-top: 30px;
  `;
  return (
    <PresentCardDiv>
        <PresentImage src="https://nfttopshot-template.onrender.com/template-images/present.png"/>
        <p>NFTプレゼント通知を受け取りますか？</p>
        <p>Apple Walletにpushpassを追加するとpush通知が受け取れます。</p>
        <p>※現在 iPhoneのみで利用可能</p>
        <AcceptButton/>
        <SkipButton/>
    </PresentCardDiv>
  );
};